module.exports = __webpack_public_path__ + "static/media/img116.9bcff393.jpg";